import {ReactNode} from 'react';

import {
  ThemeProviderWithoutClassic as ConvUIThemeProviderWithoutClassic,
  MessagePartComponentProvider,
  type Theme,
} from '@stripe-internal/conversations-ui';
import {InlineDataComponentRegistry} from '@stripe-internal/inline-data';
import type {MessagePartComponentRegistry} from '@stripe-internal/conversations-ui';
import {Observability} from '@stripe-internal/conversations-client';

import {AppCloseHandler, AppConfig, AppProfile} from '../../core/types';
import {AppProvider} from '../../core/providers/AppProvider';
import {ConversationsUIFlagsProvider} from './ConversationsUIFlagsProvider';
import {InlineDataProvider} from '../../core/providers/InlineDataProvider';
import {ParentMessageBus} from '../../core/lib/parentMessageBus/ParentMessageBus';

type Props = {
  config: AppConfig;
  profile: AppProfile;
  clientFetch?: typeof fetch;
  parentMessageBus?: ParentMessageBus;
  inlineDataComponents?: InlineDataComponentRegistry;
  messagePartComponents?: MessagePartComponentRegistry;
  children: ReactNode;
  onClose?: AppCloseHandler;
  observability?: Observability;
  theme?: Theme;
  themeOverrides?: Partial<Theme>;
};

export function StripeAssistantProviders({
  config,
  profile,
  clientFetch,
  parentMessageBus,
  inlineDataComponents,
  messagePartComponents,
  onClose,
  observability,
  children,
  theme,
  themeOverrides,
}: Props) {
  return (
    <ConvUIThemeProviderWithoutClassic value={theme} overrides={themeOverrides}>
      <AppProvider
        config={config}
        profile={profile}
        clientFetch={clientFetch}
        parentMessageBus={parentMessageBus}
        onClose={onClose}
        observability={observability}
      >
        <ConversationsUIFlagsProvider>
          <MessagePartComponentProvider value={messagePartComponents}>
            <InlineDataProvider components={inlineDataComponents}>
              {children}
            </InlineDataProvider>
          </MessagePartComponentProvider>
        </ConversationsUIFlagsProvider>
      </AppProvider>
    </ConvUIThemeProviderWithoutClassic>
  );
}
